// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.product-header[data-v-2195be08]{background-color:#ccecf9;text-transform:uppercase}div.product-header .icon[data-v-2195be08]{margin-top:-.18rem}", ""]);
// Exports
module.exports = exports;
